import { StateController } from '@1x2network/state_controller'
import { GameViews } from '../views/GameViews'
import { BaseState } from './state/BaseState'
import { HoldAndWinState } from './state/HoldAndWinState'

/**
 * Initialises the state controller for this game
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class CrazyTikiController extends StateController<GameViews, [BaseState, HoldAndWinState]> {
    protected initialise(views: GameViews): void {
        this.states = [new BaseState(views), new HoldAndWinState(views)]
    }
}
